import React, { Component } from 'react';
import { Container, Table } from 'react-bootstrap';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import { AdminNav, Loading } from '../../helpers';

import './styleTable.css';

class Certificate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FinancialSheet: null,
      listInComplete: true,
    };
    this.handleViewComplete = this.handleViewComplete.bind(this)
    this.handleViewInComplete = this.handleViewInComplete.bind(this)
  }

  componentWillMount() {
    axios
      .get(
        'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
        {
          params: {
            action: 'viewAllWageSheetComplete',
          },
        }
      )
      .then(res => {
        this.setState({ FinancialSheet: res.data });
        // console.log(res.data);
      });
  }
  handleTableClick = e => {
    console.log(e.target.parentElement.id);
    this.props.history.push({
      pathname: './CertiPage',
      state: this.state.FinancialSheet[e.target.parentElement.id],
    });
  };
  handleViewInComplete() {
    axios
      .get(
        'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
        {
          params: {
            action: 'viewAllWageSheetInComplete',
          },
        }
      )
      .then(res => {
        this.setState({
          FinancialSheet: res.data,
          listInComplete: true,
        });
      });
  }
  handleViewComplete() {
    axios
      .get(
        'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
        {
          params: {
            action: 'viewAllWageSheetComplete',
          },
        }
      )
      .then(res => {
        this.setState({
          FinancialSheet: res.data,
          listInComplete: false,
        });
      });
  }

  render() {
    let { FinancialSheet } = this.state;
    if (!FinancialSheet) {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
    return (
      <Container>
        <AdminNav />
        {/* <Nav className="justify-content-end">
                        <Link to={{ pathname: '/AddJob', state:  'bar' }}><Button variant="success">เพิ่ม</Button></Link>
                    </Nav> */}
        <Table bordered hover>
          <thead>
            <tr>
              <th scope="col">วันที่</th>
              <th scope="col">เลขแจ้งขอตรวจสอบ</th>
              <th scope="col">ชื่อบริษัท</th>
              <th scope="col">วันบรรทุกสินค้า</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.state.FinancialSheet).map(res => {
              let c = this.state.FinancialSheet[res];
              if (res === 'requestCount') {
                return null;
              }
              return (
                <tr id={res} onClick={this.handleTableClick}>
                  <td>{c.description.requestDate}</td>
                  <td>{c.description.requestID}</td>
                  <td>{c.description.companyID}</td>
                  <td>{c.description.shippingDate}</td>
                </tr>
              );
            })}

          </tbody>

        </Table>

      </Container>
    );
  }
}

export default withRouter(Certificate);

